"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configApi = configApi;
exports.configUpdateApi = configUpdateApi;
exports.promoterApplyApproveApi = promoterApplyApproveApi;
exports.promoterApplyInfoApi = promoterApplyInfoApi;
exports.promoterApplyListApi = promoterApplyListApi;
exports.promoterApplyRejectApi = promoterApplyRejectApi;
exports.promoterListApi = promoterListApi;
exports.spreadClearApi = spreadClearApi;
exports.spreadListApi = spreadListApi;
exports.spreadOrderListApi = spreadOrderListApi;
exports.spreadStatisticsApi = spreadStatisticsApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @description 分销设置 -- 详情
 */
function configApi() {
  return (0, _request.default)({
    url: '/admin/store/retail/spread/manage/get',
    method: 'get'
  });
}

/**
 * @description 分销设置 -- 表单提交
 */
function configUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/store/retail/spread/manage/set',
    method: 'post',
    data: data
  });
}

/**
 * @description 分销员 -- 列表
 */
function promoterListApi(params) {
  return (0, _request.default)({
    url: '/admin/store/retail/list',
    method: 'get',
    params: params
  });
}

/**
 * @description 推广人 -- 列表
 */
function spreadListApi(params, data) {
  return (0, _request.default)({
    url: '/admin/store/retail/spread/userlist',
    method: 'post',
    params: params,
    data: data
  });
}

/**
 * @description 推广人订单 -- 列表
 */
function spreadOrderListApi(params, data) {
  return (0, _request.default)({
    url: '/admin/store/retail/spread/orderlist',
    method: 'post',
    params: params,
    data: data
  });
}

/**
 * @description 推广人 -- 清除上级推广人
 */
function spreadClearApi(id) {
  return (0, _request.default)({
    url: "/admin/store/retail/spread/clean/".concat(id),
    method: 'get'
  });
}

/**
 * @description 分销统计
 */
function spreadStatisticsApi(params) {
  return (0, _request.default)({
    url: "/admin/store/retail/statistics",
    method: 'get',
    params: params
  });
}

/**
 * @description 团长审核 -- 团长申请分页列表
 */
function promoterApplyListApi(params) {
  return (0, _request.default)({
    url: '/admin/promoter/apply/list',
    method: 'get',
    params: params
  });
}

/**
 * @description 团长审核 -- 团长申请详情
 */
function promoterApplyInfoApi(id) {
  return (0, _request.default)({
    url: "/admin/promoter/apply/info/".concat(id),
    method: 'get'
  });
}

/**
 * @description 团长审核 -- 审核通过（自动设置 isPromoter + 创建自提点）
 */
function promoterApplyApproveApi(id) {
  return (0, _request.default)({
    url: "/admin/promoter/apply/approve/".concat(id),
    method: 'post'
  });
}

/**
 * @description 团长审核 -- 审核拒绝
 * @param {String|Number} id
 * @param {Object} data { remark }
 */
function promoterApplyRejectApi(id, data) {
  return (0, _request.default)({
    url: "/admin/promoter/apply/reject/".concat(id),
    method: 'post',
    data: data
  });
}